module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/app-card-tide-3e9c6b733d76a4e0ee32f9e3f8e0c8cb.webp";